import { ASNFormData } from '../types/asn';
import { InvoiceFormData } from '../types/invoice';

export function exportToJSON(data: ASNFormData | InvoiceFormData): string {
  if ('invoiceNumber' in data) {
    return exportInvoiceToJSON(data as InvoiceFormData);
  }
  return exportASNToJSON(data as ASNFormData);
}

export function exportASNToJSON(data: ASNFormData): string {
  const exportData = {
    purposeCode: data.purposeCode,
    shipmentIdentification: data.shipmentIdentification,
    date: data.date,
    time: data.time,
    timeCode: data.timeCode,
    dates: data.dates,
    grossWeight: data.grossWeight,
    packagingCode: data.packagingCode,
    ladingQuantity: data.ladingQuantity,
    scacCode: data.scacCode,
    carrierIdentificationQualifier: data.carrierIdentificationQualifier,
    carrierIdentificationCode: data.carrierIdentificationCode,
    carrierReferenceNumber: data.carrierReferenceNumber,
    transportationMethod: data.transportationMethod,
    routing: data.routing,
    equipmentDescriptionCode: data.equipmentDescriptionCode,
    equipmentInitial: data.equipmentInitial,
    equipmentNumber: data.equipmentNumber,
    shipmentMethodOfPayment: data.shipmentMethodOfPayment,
    references: data.references,
    orders: data.orders,
  };

  return JSON.stringify(exportData, null, 2);
}

export function exportInvoiceToJSON(data: InvoiceFormData): string {
  const exportData = {
    purposeCode: data.purposeCode,
    invoiceNumber: data.invoiceNumber,
    invoiceDate: data.invoiceDate,
    invoiceType: data.invoiceType,
    purchaseOrderNumber: data.purchaseOrderNumber,
    purchaseOrderDate: data.purchaseOrderDate,
    currencyCode: data.currencyCode,
    paymentTerms: data.paymentTerms,
    paymentTermsDescription: data.paymentTermsDescription,
    dates: data.dates,
    references: data.references,
    names: data.names,
    details: data.details,
    headerAllowancesCharges: data.headerAllowancesCharges,
    headerTaxes: data.headerTaxes,
    summary: data.summary,
  };

  return JSON.stringify(exportData, null, 2);
}

export function downloadJSON(data: ASNFormData | InvoiceFormData, filename?: string) {
  const jsonString = exportToJSON(data);
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;

  if (!filename) {
    if ('invoiceNumber' in data) {
      filename = `Invoice_${data.invoiceNumber}_${data.invoiceDate}.json`;
    } else {
      filename = `ASN_${data.shipmentIdentification}_${data.date}.json`;
    }
  }

  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
